var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.998,
    height: 11.998,
    viewBox: "0 0 11.998 11.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_71777",
    "data-name": "Group 71777",
    transform: "translate(15088.25 -5054)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M32.414,32.264V27.87c0-2.16-.465-3.809-2.985-3.809a2.6,2.6,0,0,0-2.355,1.29h-.03V24.255H24.66v8.009h2.49V28.29c0-1.05.195-2.055,1.485-2.055s1.29,1.185,1.29,2.115v3.9h2.49Z",
    transform: "translate(-15108.666 5033.734)",
    fill: "#9fa2a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M19.26,24.32h2.49v8.009H19.26Z",
    transform: "translate(-15107.315 5033.669)",
    fill: "#9fa2a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M20.44,19a1.447,1.447,0,1,0,1.44,1.44A1.44,1.44,0,0,0,20.44,19Z",
    transform: "translate(-15107.25 5035)",
    fill: "#9fa2a5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.8fda4c37cd778426374e508b92c94a52.svg";
export { ForwardRef as ReactComponent };